import Image from "next/image";
import React from "react";
import { BsArrowRight } from "react-icons/bs";

export interface BlogOrCaseStudyContent {
    mediaUrl: string;
    bannerTitle: string;
    bannerDescription: string;
    buttonText?: string;
    redirectUrl: string;
}

interface BlogOrCaseStudy {
    mainTitle?: string | JSX.Element;
    mainDescription?: string | JSX.Element;
    bannerContent: BlogOrCaseStudyContent[];
}

const BlogOrCaseStudy: React.FC<BlogOrCaseStudy> = (props) => {
    const { mainTitle, mainDescription, bannerContent } = props;
    return (
        <div className="lg:max-w-6xl lg:mx-auto w-fit mx-2 my-20 flex flex-col lg:gap-10 gap-8 items-center">
            <div className="flex flex-col gap-5">
                {mainTitle && <h3 className="lg:text-3xl text-2xl font-bold text-gray-700 text-center">{mainTitle}</h3>}
                {mainDescription && <p className="text-base font-normal text-gray-500 text-center">{mainDescription}</p>}
            </div>
            <div className="max-w-6xl flex lg:flex-row flex-col lg:gap-8 gap-6">
                {bannerContent.map((content) => {
                    const { mediaUrl, bannerTitle, bannerDescription, redirectUrl, buttonText = "Read Now" } = content;
                    return (
                        <a
                            key={bannerTitle}
                            className="lg:w-1/2 w-fit lg:mx-0 mx-2 flex flex-col border border-solid border-gray-200 rounded-xl hover:no-underline"
                            href={redirectUrl}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Image
                                width={586}
                                height={260}
                                src={mediaUrl}
                                alt={bannerTitle}
                                className="w-full flex-shrink-0 rounded-t-xl"
                                objectFit="cover"
                                style={{ height: "260px" }}
                            />
                            <div className={`${bannerContent.length === 2 ? "lg:p-8 gap-4" : "lg:p-4 gap-3"} p-5 flex flex-col`}>
                                <h4 className="truncate-heading text-2xl font-medium text-gray-600 lg:max-h-16 mb-5">{bannerTitle}</h4>
                                <p className="truncate-description text-base font-normal text-gray-500 lg:max-h-24">{bannerDescription}</p>
                                <button className="hover:underline focus:outline-none flex items-center gap-2 text-base font-medium text-blue-500" style={{ color: "#3182CE" }}>
                                    {buttonText}
                                    <span>
                                        <BsArrowRight />
                                    </span>
                                </button>
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default BlogOrCaseStudy;
